import { connect } from 'react-redux';
import ProjectedBalanceSheetView from './BalanceSheetView';

const mapStateToProps = (state, ownProps) => {
  let subdivision = state.BalanceSheet[ownProps.clientId];
  return {
    clientId: ownProps.clientId,
    is_initialized: subdivision ? subdivision.is_initialized : false,
    ProjectedItems: subdivision ? subdivision.ProjectedItems : null,
    errors: subdivision ? subdivision.errors : null,
    is_current: subdivision ? subdivision.is_current : ownProps.is_current,
    year: subdivision
      ? subdivision.year
      : `'${moment().format('YY')}-'${moment()
          .add(1, 'years')
          .format('YY')}`,
    PrincipalAgeOptions: subdivision ? subdivision.PrincipalAgeOptions : [],
    SpouseAgeOptions: subdivision ? subdivision.SpouseAgeOptions : [],
    PrincipalName: subdivision ? subdivision.PrincipalName : [],
    SpouseName: subdivision ? subdivision.SpouseName : [],
    OwnerOptions: subdivision ? subdivision.OwnerOptions : [],
    owners: subdivision ? subdivision.owners : null,
    BalanceSheet: subdivision ? subdivision.BalanceSheet : [],
    isPrint: ownProps.isPrint,
    title: ownProps.title,
  };
};

const BalanceSheet = connect(mapStateToProps)(ProjectedBalanceSheetView);

export default BalanceSheet;
